import { getJSON, get, set } from 'js-cookie';
import { Lang } from 'src/types';

export enum Cookie {
  Branch = 'huBv',
  CookieControl = 'CookieControl',
  Footfall = 'FOOTFALL_SESSION',
  Lang = 'huLang',
  Referrer = 'huReferrer',
  Session = 'huSessID',
}

export enum CookieCategory {
  Advertising = 'advertising',
  Analytics = 'analytics',
  Functionality = 'functionality',
}

const ONE_YEAR = 365;

export const setFootfallCookie = (cookie: object) => {
  set(Cookie.Footfall, cookie, { expires: ONE_YEAR});
};

export const setReferrerCookie = (referrer: string) => {
  if (referrer === get(Cookie.Referrer)) return;
  set(Cookie.Referrer, referrer, { expires: ONE_YEAR });
};

export const getBranch = () => {
  const branch = get(Cookie.Branch);
  return branch ? branch : 'A';
};

export const getLangCookie = () => {
  const lang = get(Cookie.Lang);
  return lang ? lang : 'en';
};

export const setLangCookie = (lang: Lang) => {
  set(Cookie.Lang, lang, { expires: ONE_YEAR });
};

export const isCookieConsentGiven = (category: CookieCategory) => {
  const ccCookie = getJSON(Cookie.CookieControl);
  return ccCookie?.optionalCookies?.[category] === 'accepted' ? true : false;
};
